<template>
  <Authentication v-if="indicator">
    <div class="auth-layout-form">
      <p v-if="!showMessage" class="text-center">
        ایمیل شما تایید شد.
      </p>
      <b-alert
        dismissible
        fade
        show
        @dismissed="hideAlert"
        v-for="(error, index) in alertMessage"
        :key="index"
        variant="danger"
      >
        {{ error }}
      </b-alert>
      <div class="d-flex justify-content-between p-3">
        <router-link to="/login">ورود</router-link>
        <router-link to="/register">ثبت نام</router-link>
      </div>
    </div>
  </Authentication>
</template>

<script>
import { emailVerification } from "@/services/auth";
import Authentication from "../Authentication";
import { mapState, mapActions } from "vuex";
import { SHOW_MESSAGE, HIDE_MESSAGE } from "@/store/mutation-types";

export default {
  name: "EmailVerification",
  components: {
    Authentication
  },
  data() {
    return {
      indicator: false
    };
  },
  computed: {
    ...mapState("auth", ["showMessage", "alertMessage"])
  },
  mounted() {
    this.emailVerify();
  },
  methods: {
    ...mapActions("auth", [SHOW_MESSAGE, HIDE_MESSAGE]),
    hideAlert: function() {
      this[HIDE_MESSAGE]();
    },
    emailVerify: async function() {
      const [error, data] = await emailVerification({
        token: this.$route.params.token
      });
      this.indicator = true;
      if (error) this[SHOW_MESSAGE](error);
      else {
        if (data.apiStatus === 200) {
          this.$router.push("/login");
        } else {
          this[SHOW_MESSAGE](data.apiErrors);
        }
      }
    }
  }
};
</script>

<style scoped></style>
